const translationData = (translations: { [key: string]: string } = {}) => {
  const {
    guide: guideLabel = 'Guide',
    walkAround: walkAroundLabel = 'Walk Around',
    go: goButtonLabel = "Let's go",
    waClick: waClickLabel = 'Click the rings for moving to the spot',
    waKeyboard: waKeyboardLabel = 'Or use the WASD keys to move around',
    waMouse: waMouseLabel = 'Click and drag to loop around',
    waSpace: waSpaceLabel = 'Click on space button for the next stage',
    engagement: engagementLabel = 'Engagement',
    eVirtualButtons:
      eVirtualButtonsLabel = 'Search for the virtual buttons for interact with the tour',
    eBookButton: eBookButtonLabel = 'Check the journey book for more information and progress',
    eGoButton: eGoButtonLabel = 'Click on space button for the next stage',
  } = translations;

  return {
    guideLabel,
    walkAroundLabel,
    goButtonLabel,
    waClickLabel,
    waKeyboardLabel,
    waMouseLabel,
    waSpaceLabel,
    engagementLabel,
    eVirtualButtonsLabel,
    eBookButtonLabel,
    eGoButtonLabel,
  };
};

export { translationData };
